import TiptapLink from '@tiptap/extension-link';

export const Link = TiptapLink.extend({
    inclusive: false,

    parseHTML() {
        return [
            {
                tag: 'a[href]:not([data-type="button"]):not([href *= "javascript:" i])',
            },
        ];
    },
});

export default Link;
